import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const failures = [{
  title: 'Más Café',
  desc: 'Te da un empujón, pero luego el bajón es más fuerte.'
}, {
  title: 'Suplementos',
  desc: 'El efecto era temporal o no notaste cambios reales.'
}, {
  title: 'Dormir Más Horas',
  desc: 'Pero seguías despertando sin energía.'
}, {
  title: 'Rutinas Extremas',
  desc: 'Demasiado exigentes y no pudiste sostenerlas.'
}];
export function FailedSolutions() {
  return <section className="py-16 md:py-24 bg-[#0a0a0a] relative" data-id="element-56">
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#1f1f1f_1px,transparent_1px),linear-gradient(to_bottom,#1f1f1f_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)] opacity-20 pointer-events-none" data-id="element-57" />

      <div className="max-w-4xl mx-auto px-4 relative z-10" data-id="element-58">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10 md:mb-16" data-id="element-59">
          <h2 className="text-2xl md:text-4xl font-bold text-white mb-4 md:mb-6" data-id="element-60">
            Por Qué Lo Que Has Intentado{' '}
            <span className="text-gray-500 line-through decoration-red-500 decoration-2" data-id="element-61">
              No Ha Funcionado
            </span>
          </h2>
          <p className="text-sm md:text-base text-gray-400 max-w-2xl mx-auto" data-id="element-62">
            Has intentado distintas soluciones, pero tal vez te ha pasado esto:
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6 mb-10 md:mb-16" data-id="element-63">
          {failures.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-[#111] p-5 md:p-6 rounded-lg border border-white/5" data-id="element-64">
              <div className="flex items-center gap-3 mb-2 md:mb-3" data-id="element-65">
                <XCircle className="text-gray-500" size={18} data-id="element-66" />
                <h3 className="text-lg md:text-xl font-bold text-white" data-id="element-67">
                  {item.title}
                </h3>
              </div>
              <p className="text-sm md:text-base text-gray-400" data-id="element-68">{item.desc}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center max-w-2xl mx-auto" data-id="element-69">
          <h3 className="text-xl md:text-2xl font-bold text-white mb-3 md:mb-4" data-id="element-70">
            ¿Por qué no funcionaron?
          </h3>
          <p className="text-lg md:text-xl text-cyan-400 font-medium mb-4 md:mb-6" data-id="element-71">
            Porque atacaban el síntoma, no la causa.
          </p>
          <p className="text-sm md:text-base text-gray-300 leading-relaxed" data-id="element-72">
            La verdadera causa es que tu cuerpo ha perdido su sintonía natural.
            Se ha acostumbrado a un entorno que no le permite recargar energía,
            porque el ritmo de luz, sueño y estrés está alterado.
            <br data-id="element-73" />
            <br data-id="element-74" />
            <span className="text-white font-semibold" data-id="element-75">
              No es que tu cuerpo falló. Es que se desajustó.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}